import { Component, OnDestroy, OnInit } from "@angular/core";
import { OrderEs } from "@edp-models/ES/es-order.model";
import { EnvService } from "@edp-services/env.service";
import { GetOrderEs } from "@edp-store/actions/ES/order-es.actions";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { getOrderEs } from "@edp-store/selectors/ES/order-es.selectors";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { Store, select } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subject, combineLatest } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
    selector: "edp-widget-solar",
    templateUrl: "./edp-widget-solar.component.html",
    styleUrls: ["./edp-widget-solar.component.scss"],
})
export class EdpWidgetSolarComponent implements OnInit, OnDestroy {
    public order: OrderEs;
    public dateFormatted: string;
    private unsubscribe = new Subject();
    public cardPushImageDesk: string = null;
    public cardPushImageMobile: string = null;
    public isAppiOS = false;
    public isAndroid = false;
    public inRegisterInstallation = false;

    constructor(
        private storeEs: Store<IAppEsState>,
        private envService: EnvService,
        private translate: TranslateService,
        private deviceDetector: DeviceDetectorService
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.storeEs.pipe(
                select(getContractEs),
                filter(c => !!c)
            ),
            this.storeEs.pipe(select(getOrderEs)),
        ])
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(([contract, order]) => {
                if (!!order && order.contractId === contract.id) {
                    this.order = order;
                    this.inRegisterInstallation = order?.indexStepActive === 3;
                    return;
                }
                this.storeEs.dispatch(new GetOrderEs(contract.id));
            });

        this.isAppiOS = this.deviceDetector.getDeviceInfo().os.toLowerCase() === "ios";

        this.cardPushImageDesk =
            `${this.envService.appUrl()}/resource/image/` +
            this.translate.instant("pt.edp.edponline.solar.card.widget.app.solar.thumb.desk");
        this.cardPushImageMobile =
            `${this.envService.appUrl()}/resource/image/` +
            this.translate.instant("pt.edp.edponline.solar.card.widget.app.solar.thumb.mobile");
    }

    redirectLinkDesk() {
        this.redirectExternal("pt.edp.edponline.solar.card.widget.app.solar.link.desk");
    }

    redirectLinkMobile() {
        this.isAppiOS
        ? this.redirectExternal("pt.edp.edponline.solar.card.widget.app.solar.link.ios")
        : this.redirectExternal("pt.edp.edponline.solar.card.widget.app.solar.link.android");
    }

    redirectExternal(label: string) {
        const url = this.translate.instant(label);
        window.open(url, "_self");
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
